<template>
  <footer class="footer bg-white text-dark">
    <div class="container">
      <div class="row">
        <!-- Brand Section -->
        <div class="col-md-3 mb-4 mb-md-0">
          <a href="/" class="footer-brand">
            <img
              src="@/assets/logo.svg"
              alt="Golden Palms Home Health Care"
              class="footer-logo"
            />
          </a>
          <p class="footer-text mt-2">
            © 2024 Golden Palms Home Health Care, Inc. All rights reserved.
          </p>
        </div>
        <!-- Contact Section -->
        <div class="col-md-5 mb-4 mb-md-3">
          <h5 class="footer-heading footer-heading-large">Contact Us</h5>
          <ul class="footer-contact footer-contact-large">
            <li>
              <i class="bi bi-envelope"></i>
              <a href="mailto:goldenpalmshhc@yahoo.com" class="footer-link">
                goldenpalmshhc@yahoo.com
              </a>
            </li>
            <li>
              <i class="bi bi-telephone"></i>
              <a href="tel:+17603180000" class="footer-link">
                (760) 318-0000
              </a>
            </li>
            <li class="footer-address-container">
              <i class="bi bi-geo-alt footer-address-icon"></i>
              <address class="footer-address">
                71703 Highway 111. Suite 1A <br />
                Rancho Mirage, CA 92270
              </address>
            </li>
          </ul>
        </div>
        <!-- Office Hours Section -->
        <div class="col-md-4">
          <h5 class="footer-heading footer-heading-small">Office Hours</h5>
          <p class="footer-text footer-text-small">
            Monday through Friday 10:00 am to 4:00 pm
          </p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterS",
};
</script>

<style scoped>
.footer {
  padding: 20px 0;
  background-color: #ffffff;
  border-top: 1px solid #e0e0e0;
}

.footer-brand {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

.footer-logo {
  height: 40px;
}

.footer-text {
  color: #6c757d;
  font-size: 0.875rem;
}

.footer-heading {
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 1rem;
  color: #212529;
}

.footer-heading-large {
  font-size: 1.5rem;
}

.footer-heading-small {
  font-size: 1rem;
}

.footer-contact,
.footer-nav {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-contact li,
.footer-nav li {
  margin-bottom: 12px;
  display: flex;
  align-items: flex-start; /* Align items to the start (top) */
}

.footer-link {
  color: #212529;
  text-decoration: none;
  margin-left: 8px; /* Adjust as needed */
}

.footer-link:hover {
  color: #007bff;
}

.footer-address-container {
  display: flex;
  align-items: flex-start; /* Align items to the start (top) */
}

.footer-address-icon {
  margin-right: 8px; /* Adjust as needed */
}

.footer-address {
  font-style: normal;
}

.footer-contact-large {
  font-size: 1rem;
}

.footer-text-small {
  font-size: 0.75rem;
}

@media (max-width: 768px) {
  .footer-heading {
    font-size: 1.125rem;
  }

  .footer-logo {
    height: 30px;
  }
}
</style>
